'use strict';

var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);
var notify = require('notify');
var triggerCustomEvent = require('trigger-custom-event');

var appDom = require('./app-dom');
var dataMgr = require('./data-mgr');
var sidePanel = require('./side-panel');

var addEventHandlers = function() {

	appDom.document.on('image_grid_add_to_cart_btn_clicked slideshow_add_to_cart_btn_clicked', function(e, data) {

		openAddToCartPanel(data.imageIndex, data.photoId);

	});

};

var openAddToCartPanel = function(imageIndex, photoId) {

	$.ajax({
		type: 'POST',
		url: '?page=buy_panel',
		dataType: 'JSON',
		data: {
			'photoId': photoId
		}
	}).done(onOpenAddToCartPanelDone);

};

var onOpenAddToCartPanelDone = function(response) {

	if (response.status.code) {

		sidePanel.open(response.markup);

	} else {

		triggerCustomEvent(response.status.detail, {
			data: {
				response: response
			}
		});

	}

};

var init = function() {

	addEventHandlers();

};

module.exports = {

	init: init

};
